import { AxiosResponse } from "axios";
import { _get, _aiTraceAsError } from "./BaseApiService";

const RightToWork_CHECKS_API = "RightToWork/GetRightToWorkChecks";

/** Shape of a single Right To Work check record returned by GetRightToWorkChecks. */
export interface RightToWorkCheckRow {
    status: string;
    providerId: string;
    provider: string;
    professionalName: string;
    contactName: string;
    contactNo: string;
    lastUpdatedOn: string;
    lastUpdatedBy: string;
}

/**
 * Service for fetching Right To Work verification check records.
 * Calls GET /api/GetRightToWorkChecks with optional filter parameters.
 */
class RightToWorkChecksService {
    /**
     * Retrieves Right To Work check records, optionally filtered by check status.
     *
     * @param pendingRightToWorkChecks - Optional status filter for Right To Work check results.
     */
    getRightToWorkChecks(pendingRightToWorkChecks?: string): Promise<AxiosResponse<any>> {
        const params = pendingRightToWorkChecks
            ? `?pendingRightToWorkChecks=${encodeURIComponent(pendingRightToWorkChecks)}`
            : "";
        return _get(RightToWork_CHECKS_API + params);
    }

    /**
     * Forwards to AppInsights error tracing.
     * Exposed here so callers do not need to import BaseApiService directly.
     */
    traceAsErrorToAppInsights(message: string): boolean {
        return _aiTraceAsError(message);
    }
}

export default RightToWorkChecksService;
